import {
  Box, Typography, styled,
} from '@material-ui/core';

export const ContentContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: '100vh',
});

export const HeaderBox = styled(Box)({
  marginTop: 32,
  marginBottom: 8,
});

export const Title = styled(Typography)({
  marginBottom: 8,
});

export const SubmitButtonBox = styled(Box)({
  marginTop: 8,
});
